import { Component } from "react";
import ArrowsPaging from "../ArrowsPaging";

import "./style.scss";

class TitleWithPaging extends Component {
    changePage=(value)=> {        
        if(this.props.onPageChange) this.props.onPageChange(value);
    }

    render() {
        return (
            <>
                <div className="title-bar-paging row">
                    <h4>Gold Congratulations</h4>
                    <ArrowsPaging page={this.props.page} pages={this.props.pages} onPageChange={this.changePage} />
                </div>
            </>
        )
    }
}

export default TitleWithPaging;